import React from 'react';
import customizeVmtData from '../../assets/home/featured-tools/customize-vmt-data.png';
import advancedAnalysis from '../../assets/home/featured-tools/advanced-analysis.png';
import davisPolicy from '../../assets/home/featured-tools/davis-policy.png';
import elecData from '../../assets/home/featured-tools/elec-data.png';
import electricityDownload from '../../assets/home/featured-tools/electricity-download.png';
import electricityPng from '../../assets/home/featured-tools/electricity-png.png';
import energyScenarios from '../../assets/home/featured-tools/energy-scenarios.png';
import relatedPolicies from '../../assets/home/featured-tools/related-policies.png';
import scenarios from '../../assets/home/featured-tools/scenarios.png';
import sfData from '../../assets/home/featured-tools/sf-data.png';
import sfEnvironment from '../../assets/home/featured-tools/sf-environment.png';
import vmtModifiedChart from '../../assets/home/featured-tools/vmt-modified-chart.png';
import { HomeSectionShell } from './HomeSectionShell';
import { FEATURED_MEMBER_TOOLS, FEATURED_TOOLS_SECTION } from './homePageConstants';

type ToolScreenshot = {
  primary: string;
  hover?: string;
  primaryAlt: string;
  hoverAlt?: string;
};

const TOOL_SCREENSHOTS: Record<string, ToolScreenshot> = {
  'data-download': {
    primary: electricityDownload,
    hover: elecData,
    primaryAlt: 'Download Data modal with electricity datasets selected',
    hoverAlt: 'Electricity consumption data table export preview',
  },
  'custom-portal': {
    primary: sfData,
    hover: sfEnvironment,
    primaryAlt: 'Custom portal data and indicators for a member jurisdiction',
    hoverAlt: 'Custom portal environment and climate content section',
  },
  'advanced-analysis': {
    primary: advancedAnalysis,
    hover: electricityPng,
    primaryAlt: 'Advanced analysis dashboard for high-impact opportunities',
    hoverAlt: 'Electricity consumption chart export preview',
  },
  'local-government-workspace': {
    primary: vmtModifiedChart,
    hover: customizeVmtData,
    primaryAlt: 'VMT chart updated after customizing values in the data table',
    hoverAlt: 'Customizable VMT data table for local GHG alignment',
  },
  'policy-explorer': {
    primary: davisPolicy,
    hover: relatedPolicies,
    primaryAlt: 'Policy Explorer showing adopted policies for a jurisdiction',
    hoverAlt: 'Related policies panel with peer community comparisons',
  },
  'scenario-planning': {
    primary: scenarios,
    hover: energyScenarios,
    primaryAlt: 'Scenario comparison view for future emissions pathways',
    hoverAlt: 'Energy scenario planning chart with policy impacts',
  },
};

export const FeaturedToolsSection: React.FC = () => (
  <HomeSectionShell
    id="featured-tools"
    title={FEATURED_TOOLS_SECTION.title}
    subtitle={FEATURED_TOOLS_SECTION.subtitle}
  >
    <div className="home-card-grid home-card-grid--three home-feature-grid">
      {FEATURED_MEMBER_TOOLS.map((tool) => {
        const screenshots = TOOL_SCREENSHOTS[tool.id];
        const hasHoverSwap = Boolean(screenshots?.hover);

        return (
          <article key={tool.id} className="home-feature-card">
            <div
              className={`home-feature-card__screenshot${
                screenshots ? ' home-feature-card__screenshot--image' : ''
              }${hasHoverSwap ? ' home-feature-card__screenshot--swap' : ''}`}
            >
              {screenshots ? (
                <>
                  <img
                    src={screenshots.primary}
                    alt={screenshots.primaryAlt}
                    className="home-feature-card__screenshot-img home-feature-card__screenshot-img--primary"
                    loading="lazy"
                    decoding="async"
                  />
                  {screenshots.hover ? (
                    <img
                      src={screenshots.hover}
                      alt={screenshots.hoverAlt || screenshots.primaryAlt}
                      className="home-feature-card__screenshot-img home-feature-card__screenshot-img--hover"
                      loading="lazy"
                      decoding="async"
                    />
                  ) : null}
                  {hasHoverSwap ? (
                    <span className="home-feature-card__screenshot-hint">Hover to preview</span>
                  ) : null}
                </>
              ) : (
                <span
                  className="home-feature-card__screenshot-label"
                  title={'screenshotTodo' in tool ? `Screenshot placeholder: ${tool.screenshotTodo}` : undefined}
                >
                  Screenshot
                </span>
              )}
            </div>
            <span className="home-feature-card__badge">Member Feature</span>
            <h3 className="home-feature-card__title">{tool.title}</h3>
            <p className="home-feature-card__desc">{tool.description}</p>
            <a href={tool.href} className="home-feature-card__link">
              Learn more →
            </a>
          </article>
        );
      })}
    </div>
  </HomeSectionShell>
);
